export default __webpack_public_path__ + "static/media/qr_ios.c256e210.png";